import { ICardElementWithChildren } from "backend/model/model";
import { PerformanceDonut } from "design/components/charts/PerformanceDonut";
import InitiativeHeading from "design/components/texts/InitiativeHeading";
import { getPropsFromContent } from "design/types";
import { t } from "i18next";
import { IGaugeSettings } from "qpr-base/configuration/types";
import React from "react";
import CardWrapper from "../InitiativeDetailsCardWrapper";
import useBudgetUtilizationCardStyles from "./BudgetUtilizationCardStyles";

type Props = {
  initiative: ICardElementWithChildren;
  settings: IGaugeSettings;
};

const BudgetUtilizationCard = (props: Props) => {
  const { initiative, settings } = props;
  //console.log("initiative in budget card", settings);
  const classes = useBudgetUtilizationCardStyles();
  return (
    <div className={classes.container}>
      <InitiativeHeading>{t("Budget Utilization")}</InitiativeHeading>

      <CardWrapper color="696969" period={initiative.periodname || ""}>
        <div className={classes.card}>
          <PerformanceDonut element={initiative} settings={settings} />
          <div className={classes.detailsSection}>
            <div
              className={classes.budgetSection}
              key={"EXPENDITURE_prettyvalue"}
            >
              <div className={classes.title}>{t("Expenditure")}</div>
              <div className={classes.value}>
                {initiative["EXPENDITURE_prettyvalue"]}
              </div>
            </div>

            <div className={classes.budgetSection} key={"BUDGET_prettyvalue"}>
              <div className={classes.title}>{t("Budget")}</div>
              <div className={classes.value}>
                {initiative["BUDGET_prettyvalue"]}
              </div>
            </div>
          </div>
        </div>
      </CardWrapper>
    </div>
  );
};

export default BudgetUtilizationCard;
